export default __webpack_public_path__ + "static/media/gery_downarrow.f416233c.svg";